import styles from '../igrow.module.css';

export default function DecorativeBlobs() {
  return (
    <div className={styles.blobs} aria-hidden="true">
      <svg className={`${styles.blob} ${styles.blobTl}`} viewBox="0 0 340 380" fill="none">
        <path
          d="M168 18C246 8 318 78 328 164C338 250 286 342 196 358C106 374 22 312 12 220C2 128 90 28 168 18Z"
          fill="#E6D6FD"
        />
      </svg>
      <svg className={`${styles.blob} ${styles.blobTrLavender}`} viewBox="0 0 260 300" fill="none">
        <path
          d="M150 12C214 28 258 96 246 168C234 240 176 292 108 286C40 280 4 210 16 138C28 66 86 -4 150 12Z"
          fill="#E4D4FC"
        />
      </svg>
      <svg className={`${styles.blob} ${styles.blobTrPink}`} viewBox="0 0 220 280" fill="none">
        <path
          d="M86 8C150 22 214 86 208 158C202 230 140 276 78 264C16 252 -8 178 14 112C36 46 22 -6 86 8Z"
          fill="#F7B7E6"
        />
      </svg>
      <svg className={`${styles.blob} ${styles.blobBl}`} viewBox="0 0 280 300" fill="none">
        <path
          d="M92 16C164 4 248 58 266 132C284 206 236 286 156 294C76 302 8 236 8 156C8 76 20 28 92 16Z"
          fill="#F8B4E4"
        />
      </svg>
      <svg className={`${styles.blob} ${styles.blobBrLavender}`} viewBox="0 0 220 240" fill="none">
        <path
          d="M120 10C176 22 214 78 206 140C198 202 146 234 90 226C34 218 2 164 14 104C26 44 64 -2 120 10Z"
          fill="#E5D6FD"
        />
      </svg>
      <svg className={`${styles.blob} ${styles.blobBrPink}`} viewBox="0 0 240 280" fill="none">
        <path
          d="M78 12C148 2 222 62 230 138C238 214 186 272 108 270C30 268 -6 196 12 122C30 48 8 22 78 12Z"
          fill="#F8AEE0"
        />
      </svg>
    </div>
  );
}
